import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WeighindetailsPageRoutingModule } from './weighindetails-routing.module';

import { WeighindetailsPage } from './weighindetails.page';


import { CardComponent } from '../../../components/card/card.component';

import { NgChartsModule } from 'ng2-charts';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { MainnavigationComponent } from '../../../components/mainnavigation/mainnavigation.component';
import { BreadcrumbVejebonComponent } from '../../../components/breadcrumb-vejebon/breadcrumb-vejebon.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WeighindetailsPageRoutingModule,
    NgChartsModule
  ],
  declarations: [WeighindetailsPage, CardComponent, MainnavigationComponent, BreadcrumbVejebonComponent]
})
export class WeighindetailsPageModule {}
